import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/auth';
import { userPhotosUrl } from '../utils/urls';

/**
 * UserProfileRedirect Component
 *
 * Handles /u route (without username) by redirecting to:
 * - Authenticated users: /u/<their-username>/photos
 * - Unauthenticated users: /login?returnUrl=/u
 *
 * Feature: 038-url-pattern-refactor (Task T051.5)
 */
export function UserProfileRedirect() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.slug) {
      // Redirect authenticated users to their profile
      navigate(userPhotosUrl(user.slug), { replace: true });
    } else {
      // Redirect unauthenticated users to login with return URL
      navigate('/login?returnUrl=/u', { replace: true });
    }
  }, [user, navigate]);

  // Show nothing while redirecting
  return null;
}
